import React from 'react';
import {Route, Switch, Redirect} from 'react-router-dom';

import Admin from "./components/Admin";
import Av_Keys from "./components/Av_Keys";
import Auth_Codes from "./components/Auth_Codes"
import Gap_Timers from "./components/Gap_Timers"
import Freshdesk_Merge_Subjects from "./components/Freshdesk_Merge_Subjects"
import Kpi_Metrics from "./components/Kpi_Metrics"
import New_Hires from "./components/New_Hires"
import Engineer_Scores from "./components/Engineer_Scores";
import Feedback_Responses from "./components/Feedback_Responses";
import Helpdesk_Settings from "./components/Helpdesk_Settings";
import Fe_Metric_Thresholds from "./components/Fe_Metric_Thresholds";


import ErrorBoundaryRoute from '../../../../containers/ErrorBoundaryRoute';

export default ({match, regions, roles}) => (
	<div>
		<Switch>
			<ErrorBoundaryRoute exact path={`${match.url}`}>
				<Admin regions={regions} roles={roles}/>
			</ErrorBoundaryRoute>

			<ErrorBoundaryRoute exact path={`${match.url}/av_keys`}>
				<Av_Keys regions={regions} roles={roles}/>
			</ErrorBoundaryRoute>

			<ErrorBoundaryRoute exact path={`${match.url}/auth_codes`}>
				<Auth_Codes regions={regions} roles={roles}/>
			</ErrorBoundaryRoute>

			<ErrorBoundaryRoute exact path={`${match.url}/gap_timers`}>
				<Gap_Timers regions={regions} roles={roles}/>
			</ErrorBoundaryRoute>

			<ErrorBoundaryRoute exact path={`${match.url}/freshdesk_merge_subjects`}>
				<Freshdesk_Merge_Subjects regions={regions} roles={roles}/>
			</ErrorBoundaryRoute>

			<ErrorBoundaryRoute exact path={`${match.url}/engineer_scores`}>
				<Engineer_Scores regions={regions} roles={roles}/>
			</ErrorBoundaryRoute>

			<ErrorBoundaryRoute exact path={`${match.url}/kpi_metrics`}>
				<Kpi_Metrics regions={regions} roles={roles}/>
			</ErrorBoundaryRoute>

			<ErrorBoundaryRoute exact path={`${match.url}/fe_metric_thresholds`}>
				<Fe_Metric_Thresholds regions={regions} roles={roles}/>
			</ErrorBoundaryRoute>

			<ErrorBoundaryRoute exact path={`${match.url}/new_hires`}>
				<New_Hires regions={regions} roles={roles}/>
			</ErrorBoundaryRoute>

			<ErrorBoundaryRoute exact path={`${match.url}/feedback_responses`}>
				<Feedback_Responses regions={regions} roles={roles}/>
			</ErrorBoundaryRoute>

			<ErrorBoundaryRoute exact path={`${match.url}/helpdesk_settings`}>
				<Helpdesk_Settings regions={regions} roles={roles}/>
			</ErrorBoundaryRoute>

		</Switch>
	</div>
);